import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { ForgotPassword } from './forgot-password';

@Injectable()
export class ForgotPasswordService {

    constructor(private http: VnptHttpService) { }

    forgotPassword(item:ForgotPassword){
        item.Link = Config.appUrl;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        return this.http.post(Config.apiUrl + 'account/ForgotPassword', item, {headers: headers}).map(resp=>resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/forgot-password/forgot-password.service.ts